import React from 'react';
import ReactMarkdown from 'react-markdown';

import { Colors, createClasses } from '@kp/react-ui';

import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

const classes = createClasses({
  root: {
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px',
    lineHeight: '16px',
    wordBreak: 'break-word',
    color: 'inherit',
    '& p': {
      margin: 0,
    },
    '& p:not(:last-child)': {
      marginBottom: '8px',
    },
    '& ul, & ol': {
      margin: '0 0 8px',
      paddingLeft: '18px',
    },
    '& ul:last-child, & ol:last-child': {
      marginBottom: 0,
    },
    '& li': {
      marginBottom: '2px',
    },
    '& a': {
      color: Colors.Selected.text,
      textDecoration: 'underline',
    },
    '& code': {
      fontFamily: 'monospace',
      fontSize: '0.92em',
      padding: '1px 4px',
      borderRadius: '4px',
      border: `1px solid ${Colors.Neutral.border}`,
    },
    '& pre': {
      margin: '0 0 8px',
      padding: '10px 12px',
      borderRadius: '8px',
      border: `1px solid ${Colors.Neutral.border}`,
      overflowX: 'auto',
    },
    '& pre code': {
      padding: 0,
      border: 'none',
    },
    '& strong': {
      fontWeight: 600,
    },
    '& table': {
      borderCollapse: 'collapse',
      margin: '0 0 8px',
      width: '100%',
    },
    '& th, & td': {
      border: `1px solid ${Colors.Neutral.border}`,
      padding: '4px 8px',
      textAlign: 'left',
    },
    '& th': {
      fontWeight: 600,
    },
  },
});

interface MarkdownProps {
  children: string;
}

export const Markdown: React.FC<MarkdownProps> = ({ children }) => (
  <div className={classes.root}>
    <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
      {children}
    </ReactMarkdown>
  </div>
);
